import { useState, useEffect } from "react";

function createBreakpoint(breakpoint: number): boolean {
  const [isBreakpoint, setIsBreakpoint] = useState(window.innerWidth >= breakpoint);

  const handleResize = () => {
    setIsBreakpoint(window.innerWidth >= breakpoint);
  };

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [breakpoint]);

  return isBreakpoint;
}

export { createBreakpoint };
